/**
 * Determine if we need to show GDPR text based on whether the form contains
 * personal identifier fields (ssn, personnummer, pnr).
 */
export function hasGdprFields(fields) {
    return (fields || []).some(
        field => field.name === 'ssn' || field.name === 'personnummer' || field.name === 'pnr'
    );
}
